import { Buffer } from 'buffer';
import axios from '@/axios';
import { useOutlookStore } from '@/store/outlook';
import { $settings } from '@/provider/settings';

const sapUrl = $settings.middlewareSAPProxyURI;
const url = $settings.middlewareURI;

const getMailId = () =>
  window.Office.context.mailbox.convertToRestId(
    window.Office.context.mailbox.item.itemId,
    window.Office.MailboxEnums.RestVersion.v2_0,
  ) || '';

const getAttachmentId = (attachment) =>
  window.Office.context.mailbox.convertToRestId(
    attachment.id,
    window.Office.MailboxEnums.RestVersion.v2_0,
  );

export async function upload({ objKey, file, parent, type, subType }) {
  const formData = new FormData();

  formData.append('filename', file);

  if (parent) {
    for (const [key, value] of Object.entries(parent)) {
      formData.append(key, value);
    }
  }

  const {
    data: { MESSAGES, SUCCESS, DATA },
  } = await axios.post([sapUrl, type, 'upload', objKey].join('/'), formData, {
    params: { subType },
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  const errorMessages = MESSAGES.find(({ TYPE }) => TYPE === 'E');

  if (!SUCCESS || errorMessages) throw errorMessages;

  return DATA;
}

const dataUrlToFile = async (
  dataUrl,
  fileName,
  dataType,
  stringify = false,
) => {
  const buff = stringify
    ? Buffer.from(dataUrl, 'utf8')
    : Buffer.from(dataUrl, 'base64');
  return new File([buff], fileName, { type: dataType });
};

export async function addMailAttachmentsToBO({ key, type }) {
  const isMail = useOutlookStore().getIsEmailView;
  const mailID = getMailId();
  const attachmentsArray = [];

  await Promise.all(
    this.attachments.map(async (attachment) => {
      const attachmentID = getAttachmentId(attachment) || attachment.id;

      const requestUrl = isMail
        ? `${[url, 'email', 'attachments'].join(
            '/',
          )}?mailID=${mailID}&attachmentID=${attachmentID}`
        : `${[url, 'email', 'event-attachments'].join(
            '/',
          )}?eventID=${mailID}&attachmentID=${attachmentID}`;

      const response = await axios.get(requestUrl);
      const { data } = response;
      const attachmentFile = await dataUrlToFile(
        data.contentBytes,
        data.name,
        data.contentType,
      );

      await this.upload({
        objKey: key,
        file: attachmentFile,
        type,
      });

      attachmentsArray.push(attachmentFile);
    }),
  );

  return attachmentsArray;
}

export async function attachEMLToBO({ key, type }) {
  const mailID = getMailId();
  const requestUrl = `${[url, 'email', 'emlFile'].join('/')}?mailID=${mailID}`;

  const { data } = await axios.get(requestUrl);

  const attachmentFile = await dataUrlToFile(
    data,
    'EML_attachment.eml',
    'application/octet-stream',
    true,
  );

  await this.upload({
    objKey: key,
    file: attachmentFile,
    type,
  });
}
